module.exports = __webpack_public_path__ + "img/Front.a8cdc459.jpg";